import script from "./video-widget.vue?vue&type=script&setup=true&lang=js"
export * from "./video-widget.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__